export default function middleware({ next }) {
    return next();
  }
  